import is from 'ramda/src/is'
import isNil from 'ramda/src/isNil'
import merge from 'ramda/src/merge'
import Vue from 'vue'
import defaultOptions from '@/config/snotify'

class NotificationService {
  constructor() {
    this.vue = new Vue()
  }

  success(message, title = '', options = {}) {
    const toastOptions = merge(defaultOptions, options)
    this.vue.$snotify.success(message, title, toastOptions)
  }

  info(message, title = '', options = {}) {
    const toastOptions = merge(defaultOptions, options)
    this.vue.$snotify.info(message, title, toastOptions)
  }

  warn(message, title = '', options = {}) {
    const toastOptions = merge(defaultOptions, options)
    this.vue.$snotify.warning(message, title, toastOptions)
  }

  error(error, title = 'Error', options = {}) {
    let message

    if (is(String, error)) {
      message = error
    } else if (is(Object, error) && !isNil(error.response)) {
      message = error.toString()
    } else {
      log.warn('receive error to handle in unsupported format', error)
      message = error.toString()
    }

    const toastOptions = merge(defaultOptions, options)
    this.vue.$snotify.error(message, title, toastOptions)
  }
}

export default new NotificationService()
